import React from 'react';

import { Typography } from '../../designComponents';
import { DiscoverBannerStyled } from './landing-styles';

const DiscoverBanner = () => {
  return (
    <DiscoverBannerStyled>
      <Typography className="discover-title" strong>
        Discover the Ultimate Escape Plan Maker!
      </Typography>
      <Typography className="discover-desc">
        Prepare to be amazed by our incredible online escape plan! Whether
        you're an architect, safety professional, or building manager, you'll
        love the convenience and power of our platform.
      </Typography>
    </DiscoverBannerStyled>
  );
};

export default DiscoverBanner;
